import { render } from "./TwoFactorChallenge.vue?vue&type=template&id=96fe0a94"
import script from "./TwoFactorChallenge.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFactorChallenge.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Auth/TwoFactorChallenge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "96fe0a94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('96fe0a94', __exports__)) {
    api.reload('96fe0a94', __exports__)
  }
  
  module.hot.accept("./TwoFactorChallenge.vue?vue&type=template&id=96fe0a94", () => {
    api.rerender('96fe0a94', render)
  })

}


export default __exports__